import script from "./BotPausedBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./BotPausedBanner.vue?vue&type=script&lang=ts&setup=true"

import "./BotPausedBanner.vue?vue&type=style&index=0&id=162d6be4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162d6be4"]])

export default __exports__